module.exports = { id: "chevron-up", url: "/build/app/img/symbols.svg#chevron-up", viewBox: "", toString: function() { return this.url; } };